module.exports = __webpack_public_path__ + "media/echope_pedido_delivery.bae0be7e.mp3";